'use strict';

exports.__esModule = true;

var _subscribeObserverAdapter = require('./subscribeObserverAdapter');

var _subscribeObserverAdapter2 = _interopRequireDefault(_subscribeObserverAdapter);

var _defineObservable = require('./defineObservable');

var _defineObservable2 = _interopRequireDefault(_defineObservable);

var _transformNext = require('./transformNext');

var _transformNext2 = _interopRequireDefault(_transformNext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Generated by CoffeeScript 1.12.6
var map;

exports.default = map = function (priorObservable, f) {
  var subscribe;
  subscribe = (0, _subscribeObserverAdapter2.default)(function (observer) {
    return priorObservable.subscribe((0, _transformNext2.default)(observer, function (x) {
      return observer.next(f(x));
    }));
  });
  return (0, _defineObservable2.default)({
    subscribe: subscribe
  });
};